<template>
	<el-dialog width="828px" :visible.sync="previewVisible" :before-close="cancel" custom-class="preview-dialog" :close-on-click-modal="false" background-color="#f2f3f6">
		<div class="preview-imgs">
	        <span v-for="item in imageList" :key="item.id">
	            <img :src="item.url" class="imgContent">
	        </span>
		</div>
	</el-dialog>
</template>
<script>
export default {
	props:{
	    previewVisible: {
	        type: Boolean,
	        default: false
	    }
	},
	data() {
		return {
            imageList: [
                { url: require('./../../assets/preview/smallapp_preview1.png'), id: 0},
                { url: require('./../../assets/preview/smallapp_preview2.png'), id: 1},
                { url: require('./../../assets/preview/smallapp_preview3.png'), id: 2}
            ]
        }  
	},
	methods: {
		cancel() {
			this.$emit('closePreview')
		}
	}
}
</script>
<style>
.preview-dialog {
    height: 517px;
}
.preview-dialog .preview-imgs span .imgContent {
    width: 240px;
    height: 427px;
    margin-left: 11px;
    margin-right: 11px;
}
.preview-dialog .el-dialog__header {
	border-radius: 2px;
	border-bottom: none;
    background: #F2F3F6;
}
.preview-dialog .el-dialog__body {
	border-radius: 2px;
    background: #F2F3F6;
}
</style>


// WEBPACK FOOTER //
// src/components/basic/Preview.vue